import { getLocalStorage } from '@shared/core';

const LOCAL_STORAGE_REGISTRY_CURATIONS_ITEM = 'registryCurations';
const localStorage = getLocalStorage();
const CASH_FUND_PUBLIC_URL_PATH = '/shop/catalog/cash-funds';
const EXPERIENCE_PUBLIC_URL_PATH = '/shop/catalog/experiences';

export type CurationState = {
  id: string;
  title: string;
  publicUrlPath: string;
  children: ReadonlyArray<string | undefined>;
};

export const setCurationNavigationState = (curationState: CurationState | null) => {
  localStorage.setItem(LOCAL_STORAGE_REGISTRY_CURATIONS_ITEM, JSON.stringify(curationState));
};

export const getCurationNavigationState = (): CurationState | null => {
  const storedValue = localStorage.getItem(LOCAL_STORAGE_REGISTRY_CURATIONS_ITEM);
  let value: CurationState | null = null;
  try {
    if (storedValue) {
      value = JSON.parse(storedValue);
    }
  } catch (e) {}

  return value;
};

export const getIsCashfundType = (categoryPublicUrlPath?: string, lineage?: Array<{ publicUrlPath: string }>) => {
  return !!(categoryPublicUrlPath === CASH_FUND_PUBLIC_URL_PATH || lineage?.some(cat => cat.publicUrlPath === CASH_FUND_PUBLIC_URL_PATH));
};

export const getIsExperienceType = (categoryPublicUrlPath?: string, lineage?: Array<{ publicUrlPath: string }>) => {
  return !!(categoryPublicUrlPath === EXPERIENCE_PUBLIC_URL_PATH || lineage?.some(cat => cat.publicUrlPath === EXPERIENCE_PUBLIC_URL_PATH));
};
